module.exports = __webpack_public_path__ + "images/application/team/marek-8f14d821.jpg";